import { ChangeEvent, useState } from 'react';
import { ApplicationsAnalystTable } from './ApplicationsAnalystTable';
import { TextField } from 'components/common/TextField';

export const ApplicationsAnalystListingPage = () => {
  const [searchInputValue, setSearchInputValue] = useState('');

  const searchHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchInputValue(event.target.value);
  };

  return (
    <div className={'mt-8 w-full px-4'}>
      <div className={'flex items-center justify-between'}>
        <TextField
          onChange={searchHandler}
          placeholder={'Search'}
          className={'rounded-md border border-blue-500 p-2'}
          value={searchInputValue}
        />
      </div>
      <div className={'mt-8 flex flex-col items-center'}>
        <ApplicationsAnalystTable searchInputValue={searchInputValue} />
      </div>
    </div>
  );
};
